import {ActionList, ActionMenu, Button, CounterLabel} from '@primer/react'
import TypeGroup from './TypeGroup'
import {ChevronDownIcon} from '@primer/octicons-react'
import {useLoggedInContext} from '../../contexts/LoggedInContext'

import type {SearchKindCount} from '../../hooks/use-search-result-counts'
import {capitalizeFirstLetter} from '../../utilities/format-type-title'
import {CountMode} from '@github-ui/count'

import LazyCounter from '../LazyCounter'
import styles from './TypeMobileDropdown.module.css'

export default function TypeMobileDropdown({
  selectedType,
  searchKinds,
  isLoadingCounters,
}: {
  selectedType: string | undefined
  isLoadingCounters: boolean
  searchKinds: SearchKindCount[]
}) {
  const searchKindCount = searchKinds?.find(kind => kind.name === selectedType) || searchKinds[0]
  const loggedIn = useLoggedInContext()

  if (!searchKindCount) return null

  return (
    <div className={styles.dropdownWrapper}>
      <span className={styles.filterLabel} aria-hidden="true">
        Filter:
      </span>
      <ActionMenu>
        <ActionMenu.Anchor>
          <Button
            size="small"
            trailingVisual={ChevronDownIcon}
            data-testid="type-switcher"
            aria-label="Filter by type"
            className={styles.typeSwitcherButton}
          >
            {capitalizeFirstLetter(searchKindCount.readableNamePlural)}
            {selectedType !== 'ai_resources' && (
              <span className={styles.counterWrapper}>
                {selectedType === 'code' && !loggedIn ? (
                  <CounterLabel data-testid="resolved-count-label" className={styles.resolvedCountLabel}>
                    ...
                  </CounterLabel>
                ) : (
                  <LazyCounter
                    resultCountIsLowerBound={searchKindCount.mode === CountMode.LowerBound}
                    totalResults={searchKindCount.total || 0}
                    isLoading={searchKindCount.total === undefined}
                  />
                )}
              </span>
            )}
          </Button>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay width="small">
          <ActionList selectionVariant="single" data-testid="type-switcher-options">
            <TypeGroup
              isLoadingCounters={isLoadingCounters}
              selectedType={selectedType}
              searchKinds={searchKinds}
              isMobile
            />
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </div>
  )
}
